/**
 * Header navigate component
 */

// React
import React, { FC } from 'react';

// Material
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

// Styled
const HeaderNavigateContainer = styled(Box)({
  padding: '0 0 0 16px',
  height: '30px',
});

interface HeaderNavigateProps {
  linkHref: string;
  linkText: string;
  currentText: string;
}

// Component
const HeaderNavigate: FC<HeaderNavigateProps> = ({ linkHref, linkText, currentText }) => {
  return (
    <HeaderNavigateContainer>
      <Breadcrumbs separator=">" aria-label="breadcrumb">
        <Link
          sx={{ fontWeight: 'bold' }}
          variant="body1"
          underline="none"
          color="primary"
          href={linkHref}
        >
          {linkText}
        </Link>
        <Typography sx={{ fontWeight: 'bold', color: '#000000' }} variant="h3" color="inherit">
          {currentText}
        </Typography>
      </Breadcrumbs>
    </HeaderNavigateContainer>
  );
};

export default HeaderNavigate;
